export default __webpack_public_path__ + "static/media/grid4.f3e30bce.png";